module.exports = __webpack_public_path__ + "img/img_smart_phone_banner.054c76cd.png";